import { useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box } from "@dealer-center/core-components";

// Layout shell for the Inventory app. Every page migrated into the app renders
// through this <Outlet />, so shared Inventory chrome belongs here.
export const InventoryApp = () => {
  const location = useLocation();

  // Apply the default "Inventory" title once per route, during render, the
  // same way PagesControlcenterApp applies "ControlCenter". This layout stays
  // mounted across /cc/inventory/* navigations while the parent resets the
  // title on every pathname change, so a mount-only effect would lose it.
  // Render runs top-down (ControlCenter → Inventory) before any child effect,
  // so a child page's own title effect still wins.
  const titledPathnameRef = useRef<string | null>(null);
  if (titledPathnameRef.current !== location.pathname) {
    titledPathnameRef.current = location.pathname;
    document.title = "Inventory";
  }

  return (
    <Box data-testid="inventory-app">
      <Outlet />
    </Box>
  );
};
